import API from '../../api/api'

const VALET_LOAD = 'VALET_LOAD'
const VALET_CREATE = 'VALET_CREATE'
const VALET_UPDATE = 'VALET_UPDATE'
const VALET_DELETE = 'VALET_DELETE'

const initialState = {
  valetUsers: [],
}

const valetReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALET_LOAD:
      return {
        ...state,
        valetUsers: action.valetUsers,
      }
    case VALET_CREATE: {
      return {
        ...state,
        valetUsers: [action.data, ...state.valetUsers],
      }
    }
    case VALET_UPDATE: {
      return {
        ...state,
        valetUsers: state.valetUsers.map((valetUser) =>
          valetUser.id === action.data.id ? action.data : valetUser,
        ),
      }
    }
    case VALET_DELETE: {
      return {
        ...state,
        valetUsers: state.valetUsers.filter((valetUser) => action.id !== valetUser.id),
      }
    }
    default:
      return state
  }
}

export const fetchValetUsers = (buildingId) => {
  return (dispatch) =>
    API.getAllValetUsers(buildingId)
      .then((res) => {
        dispatch(loadValetUsers(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const createValet = (data) => {
  return (dispatch) =>
    API.createNewManagementUser(data, 'valet')
      .then((res) => {
        if (!res.errCode) dispatch({ type: VALET_CREATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updateValetUser = (data, id) => {
  const valetUserBody = { firstName: data.firstName, lastName: data.lastName }
  return (dispatch) =>
    API.updateValetUser(valetUserBody, id)
      .then((res) => {
        if (!res.errCode) dispatch({ type: VALET_UPDATE, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const deleteValetUser = (id) => {
  return async (dispatch) => {
    try {
      await API.deleteValetUser(id)
      dispatch({ type: VALET_DELETE, id })
    } catch ({ message }) {
      throw new Error(message)
    }
  }
}

export const loadValetUsers = (valetUsers) => {
  return {
    type: VALET_LOAD,
    valetUsers,
  }
}

export const selectValetUsers = (state) => state.valet.valetUsers

export default valetReducer
